import API from '../../../../../services/api';

export const ENVIOS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/envios?page=${page}${search || ''}`).then(res => res.data);
    },
    getByStatusId: async (estadoId, isNacional, page, search) => {
        const searcher = `&estadoId=${estadoId}&isNacional=${isNacional}&` + search; 
        return await API.get('/envios/get-by-state?page=' + page + searcher).then(res => res.data);
    },
    search: async (searchParams, page) => {
        return API.post('/envios/get-shipping-searchby?page=' + page, searchParams).then(res => res.data);
    },
    getData: async (search) => {
        return API.get('/envios-data?search=' + search).then(res => res.data);
    },
    getDetail: async (envioId) => {
        return API.get('envios/' + envioId + '/detail').then(res => res.data);
    },
    getLabel: async (envioId) => {
        return API.get('/envios/' + envioId + '/etiqueta', {responseType: 'blob'}).then(res => res.data);
    },
    getExpresswayStatus: async (numSeguimiento) => {
        return await API.get('/expressway/' + numSeguimiento + '/estado').then(res => res.data);
    },
    getHermesStatus: async (numSeguimiento) => {
        return await API.get('/hermesLogistics/' + numSeguimiento + '/estado').then(res => res.data);
    },
    getDashboard: async (startDate, endDate, clean_cache) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&cleanCache=' + clean_cache;
        return await API.get('/envios/dashboard' + params).then(res => res.data);
    },
    getNoGeneratedCount: async () => {
        return API.get('envios/get-no-generated-total').then(res => res.data);
    },
    getNoGenerated: async (page) => {
        return API.get('envios/get-all-no-generated?page=' + page).then(res => res.data);
    },
    getProviderEmailNotSent: async () => {
        return API.get('/get-provider-email-no-sent').then(res => res.data);
    },
    getAlerts: async (page, transportista) => {
        return API.get('envios/shipping-alerts?page=' + page + '&transportista=' +  transportista).then(res => res.data);
    },
    new: async (envio) => {
        return API.post('/envios', envio).then(res => res.data);
    },
    getInfo: async (data) => {
        return API.post('/envios-info', data).then(res => res.data);
    },
    sendEmailToProvider: async (envioId) => {
        return API.post('envios/' + envioId + '/email').then(res => res.data);
    },
    sendEmailToAlmacenesProvider: async (data) => {
        return API.post('envios/email-almacenes', data).then(res => res.data);
    },
    regenerate:  async (envio) => {
        return API.post('envios/regenerar/pendiente', envio).then(res => res.data);
    },
    exportConsumption: async (data) => {
        return API.post('/envios/export/consumo', data, {responseType: 'blob'}).then(res => res.data);
    },
    incident: async (envio) => {
        return API.post('/envios/' + envio.id + '/incidencia', envio).then(res => res.data);
    },
    cancel: async (envio) => {
        return API.post('/envios/' + envio.id + '/cancelar', envio).then(res => res.data);
    },
    getShippingStates: async (envio) => {
        return API.post('envios/get-shipping-states', envio).then(res => res.data);
    },
    update: async (envio) => {
        return API.put('/envios/' + envio.id, envio).then(res => res.data);
    }
}